import { Pipe, PipeTransform } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

@Pipe({
  name: "orderAction",
  standalone: false,
})
export class OrderActionPipe implements PipeTransform {
  transform(value: string): string {
    return value.toLowerCase().replace(/_/g, ".");
  }
}
